export default __webpack_public_path__ + "static/media/nodejs.ed5c8001.png";